import React from 'react';
import classNames from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentAvOPreviousYearsHit as Type } from '../../../../SearchAllContent/types';
import constructImageSourcesArray from '../../../../../helpers/constructImageSources';

import Card from '../../../../Card';

import './style.scss';

const MetaSearchAvOPreviousYearsHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchAvOPreviousYearsHit');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link href={hit.url[0]}>
          <Card.Image
            image={(
              <Image
                src={constructImageSourcesArray(hit, '16_9')}
                alt={hit.image_alt?.[0]}
                lazyload={false}
              />
            )}
          />
          <div className="MetaSearchAvOPreviousYearsHit__text-wrapper">
            <div className="Card__content__body">
              <Card.Title title={hit.year[0]} />
              <Card.Subtitle
                subtitle={(
                  <p className="u-truncate--3">
                    {hit.page_title[0]}
                  </p>
                )}
              />
            </div>
          </div>
        </Card.Link>
      </Card.Content>
    </Card>
  );
};

export default MetaSearchAvOPreviousYearsHit;
